
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import finn from "../../assets/finn.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarFinn({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar finn fordító</title>
                <meta name='description' content="Ingyenes magyar finn fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar finn fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-finn-fordito" />
            </Helmet>
            <h1>Magyar finn fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és finn nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={finn} alt="finn zászló"></img>
                </div>


                <p>Íme néhány lényeges különbség a magyar és a finn között:</p>

                <h3>Nyelvcsalád</h3>

                <p>
                    <b>Magyar</b>: A magyar finnugor nyelv, az uráli nyelvcsalád része. Ez a legszélesebb körben beszélt nem indoeurópai nyelv Európában. Nyelvi sajátosságokat mutat más uráli nyelvekkel, például az észttel.</p>
                <p><b>Finn</b>: A finn is finnugor nyelv, és az uráli nyelvcsaládhoz tartozik. Finnországban beszélik, és némi hasonlóságot mutat más finn nyelvekkel, például az észttel.
                </p>

                <h3>Nyelvtan</h3>

                <p><b>Magyar</b>: A magyarnak összetett agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. Gazdag főnévi esetrendszerrel is rendelkezik a nyelvtani szerepek jelzésére.</p>
                <p><b>Finn</b>: A finnnek is van a magyarhoz hasonló agglutinációs nyelvtana. Különféle utótagokat alkalmaz a nyelvtani információk közvetítésére, beleértve a főnévi eseteket, az igeragozásokat és a birtokosokat. A finn nyelvben jelentős számú főnévi eset található (legfeljebb 15) a nyelvtani kapcsolatok jelzésére.</p>

                <h3>Szókincs</h3>

                <p><b>Magyar</b>: A magyar szókincs egyedi, és nincs szoros rokonságban más európai nyelvekkel. Néhány szót a szomszédos nyelvekből kölcsönzött, például német, török és szláv nyelvekből.</p>
                <p><b>Finn</b>: A finn szókincs elkülönül, és viszonylag korlátozott mennyiségű kölcsönszavat tartalmaz más nyelvekből. Néhány szót kölcsönzött a svédből, amely Finnország egyik hivatalos nyelve.</p>


                <h3>Kiejtés</h3>

                <p><b>Magyar</b>: A magyar nyelvnek egyszerű hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</p>
                <p><b>Finn</b>: A finn kiejtése nagyobb kihívást jelenthet a magánhangzók harmóniája, a hosszúságkülönbségek és az összetett mássalhangzócsoportok miatt. A finn nyelvnek fonetikus helyesírási rendszere van, ami azt jelenti, hogy a szavakat általában úgy ejtik ki, ahogy írják őket.</p>

                <h3>Mondatszerkezet</h3>

                <p><b>Magyar</b>: A magyar nyelvnek van Alany-Tárgy-Ige (SOV) szórendje, ami eltér a legtöbb európai nyelv tipikus szórendjétől. Az ige általában a mondat végére kerül.</p>
                <p><b>Finn</b>: A finnnek is van Alany-Tárgy-Ige (SOV) szórendje. A mondatszerkezet viszonylag rugalmas az esetvégződések széleskörű használatának köszönhetően.</p>

                <div className="sectionbottom">
                    <Link to="/finn-magyar-fordito">Finn magyar fordító</Link>
                    <img src={finn} alt="finn zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
               
            </section>
        </>

    )
}

export default MagyarFinn;